export default {
  createSuccess: "Host creato con successo!",
  createModal: {
    title: "Aggiungi host",
    namePlaceholder: "es. Villa Panorama",
    emailPlaceholder: "host@example.com",
    create: "Crea host",
  },
  detail: {
    roleLabel: "Host",
    statStructures: "Strutture",
    loadDetail: "Caricamento dettagli host...",
    loadError: "Impossibile caricare l’host",
    toastStatusUpdated: "Stato host aggiornato",
    toastStatusError: "Impossibile aggiornare lo stato dell’host",
    toastPasswordResetSent: "Email di reset password inviata all’host.",
    housesTitle: "Strutture",
    noHouses: "Nessuna struttura ancora",
    activitiesTitle: "Attività ({{count}})",
    loadActivities: "Caricamento attività...",
    activitiesError: "Impossibile caricare le attività",
    noActivitiesTitle: "Nessuna attività",
    noActivitiesDesc: "Questo host non ha ancora attività",
  },
} as const;
